import React, { useEffect, useState } from "react";
import ContentCardSkeleton from "../contentcards/skeleton/ContentCardSkeleton";
import ContentCard from "../contentcards/ContentCard";
import CategoryContentPreview from "../sections/CategoryContentPreview";
import { Media } from "../../compilers/media";
import { getAcademyUpcoming } from "../../api/academy";
import { useTranslation } from "react-i18next";

type FeaturedAcademyContentProps = {
  title: string;
  subtitle?: string;
  smallTitle?: boolean;
  linkTitle: string;
  link: string;
};

const UpcomingAcademyContent: React.FC<FeaturedAcademyContentProps> = ({
  title,
  subtitle,
  smallTitle,
  linkTitle,
  link,
}) => {
  const { i18n, ready } = useTranslation();
  const [emptyResponse, setEmptyResponse] = useState<boolean>(false);
  const [academyContent, setAcademyContent] = useState<Media[]>([]);

  useEffect(() => {
    if (ready) {
      getAcademyUpcoming(i18n.language).then((response: Media[]) => {
        setAcademyContent(response);
        if (response.length < 1) setEmptyResponse(true);
        //console.log(response);
      });
    }
  }, [i18n.language, ready]);

  const getContent = () => {
    if (!academyContent || academyContent.length < 1) {
      return [
        <ContentCardSkeleton key={0} />,
        <ContentCardSkeleton key={1} />,
        <ContentCardSkeleton key={2} />,
        <ContentCardSkeleton key={3} />,
      ];
    }

    return academyContent.map((item) => {
      // sets the academy specific things
      item.data.bluePillText = item.data.difficulty ?? "";
      item.data.yellowPillText =
        item.data.learningPathways.length > 0
          ? item.data.learningPathways[0]
          : undefined;
      item.data.category = item.data.type;
      //remove the slug

      return (
        <div key={item.id} style={{ pointerEvents: "none", height: "inherit" }}>
          <ContentCard
            key={item.id}
            media={item}
            section_type="academyupcoming"
          />
        </div>
      );
    });
  };

  if (emptyResponse) {
    return <></>;
  }
  return (
    <CategoryContentPreview
      title={title}
      subtitle={subtitle}
      smallTitle={smallTitle}
      linkTitle={linkTitle}
      link={link}
    >
      {getContent()}
    </CategoryContentPreview>
  );
};

export default UpcomingAcademyContent;
